import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { lyricTimingMessages } from './lyricTimingMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the lyric timing; each part uses its own slice of it */
import styles from './LyricTiming.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The foot of the sync editor (design s8): the keys. Below 700px the keys go and one touch hint
 * shows instead (s11).
 */
const LyricTimingKeyHintsComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <div className={styles.foot}>
      <span className={styles.footKeys}>
        <span className={styles.kbd}>Space</span> {intl.formatMessage(lyricTimingMessages.keyPlay)}
      </span>
      <span className={styles.footKeys}>
        <span className={styles.kbd}>↑</span> <span className={styles.kbd}>↓</span>{' '}
        {intl.formatMessage(lyricTimingMessages.keyLine)}
      </span>
      <span className={styles.footKeys}>
        <span className={styles.kbd}>[</span> <span className={styles.kbd}>]</span>{' '}
        {intl.formatMessage(lyricTimingMessages.keyNudge, { shift: <span className={styles.kbd}>Shift</span> })}
      </span>
      <span className={styles.footKeys}>
        <span className={styles.kbd}>T</span> {intl.formatMessage(lyricTimingMessages.keySet)}
      </span>
      <span className={styles.footTouch}>{intl.formatMessage(lyricTimingMessages.tapToPlay)}</span>
    </div>
  );
};

export const LyricTimingKeyHints = TypedMemo(LyricTimingKeyHintsComponent);

/** The meaning of the two dots (design s8). */
const LyricTimingLegendComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <div className={styles.legend}>
      <span className={`${styles.legendDot} ${styles.dotEdited}`} />
      <span>{intl.formatMessage(lyricTimingMessages.legendChanged)}</span>
      <span className={`${styles.legendDot} ${styles.dotCheck} ${styles.legendGap}`} />
      <span>{intl.formatMessage(lyricTimingMessages.legendCheck)}</span>
    </div>
  );
};

export const LyricTimingLegend = TypedMemo(LyricTimingLegendComponent);
